import HubScreen from './index';

const routes = [
  {
    path: '/onboarding-hub',
    component: HubScreen,
  },
];

export default routes;
